
export const initialPlan = {
    name: "One Time Payment",
    price: 400,
    isMonthly: false,
    newPlan: false,
    desc: "For those serious about their health and transformation.",
    features: [
      "Daily morning diet tips",
      "Hydration reminders",
      "Weekly progress summary",
      "Daily calorie tracking",
    ],
  };

export const earlyBirdPlan = {
    name: "Early Bird Payment",
    price: 1999,
    isMonthly: false,
    newPlan: true,
    desc: "For those serious about their health and transformation.",
    features: [
        "Continue your Journey",
        "Instant Support",
    ],
};

export const normalPlan = {
    name: "Regular Payment",
    price: 2499,
    isMonthly: false,
    newPlan: true,
    desc: "For those serious about their health and transformation.",
    features: [
        "Continue your journey",
        "Instant support",
    ],
};

export const ascendraPlusPlan = {
    name: "Ascendra 42-Day Journey",
    price: 39,
    isMonthly: false,
    newPlan: true,
    desc: "42-Day AI-Powered, Neuroscience-Based Food Freedom Journey",
    features: [
        "42-Day Life-Long Pattern Rewiring Curriculum",
        "AI Coach Leslie for 42 Days",
        "Weekly Deep Reconditioning Live Calls",
        "Private Community Membership",
        "Full Resource Library",
        "Full Progress Insights",
    ],
};
